import styled from 'styled-components'
import { colors } from '../../../../theme/theme';

export const Container = styled.div`
    .ds-select { 
        border-radius: 5px;
        border-color: #EEEEEE;        
    }

    .ds-input-group  { 
        width: 60%;       
    }

    .input-text  {
        border: 1px solid #EEEEEE !important;
        /* border-right: 0px !important; */
    }

    .input-text::placeholder { 
        font-size: 14px;
        color: ${colors.greyscale.dark_grey};
    }
`;

export const MaterialsList = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 42px;

    h5 { 
        font-size: 24px;
        color: ${colors.mainColors.blueberry};
        margin-bottom: 24px;
     }
`;

export const Materials = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(300px, 1fr));
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    @media only screen and (max-width: 1200px) { 
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
`;

export const ObjectList = styled.div`

h5 { 
        font-size: 24px;
        color: ${colors.mainColors.blueberry};
        margin-bottom: 24px;
     }


`;

export const Objects = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(300px, 1fr));
    grid-column-gap: 28px;
    grid-row-gap: 16px;

    @media only screen and (min-width: 1420px) { 
        grid-column-gap: 20px;
        grid-template-columns: repeat(2, minmax(300px, 1fr));
    }

    @media only screen and (max-width: 1200px) { 
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
`;

export const Filters = styled.div`
    display: flex;

    @media only screen and (max-width: 600px) { 
        flex-direction: column;
    }
`;

export const HomeSelect = styled.div`
    width: 155px;

    @media only screen and (max-width: 600px) { 
        max-width: 450px;
    }
`;

export const HomeSearch = styled.div`
    width: 500px;
`;

